<!--  -->
<template>
  <div class="orderMain">
    <el-tabs v-model="activeName" type="border-card" @tab-click="handleClick">
      <el-tab-pane label="会员日志" name="eleven">
        <div class="title_div">
          <span class="title-span">类型：</span>
          <el-select
            v-model="liushuiParams.changeType"
            placeholder="请选择类型"
            clearable
            @change="changeTypeSelect"
            size="small"
          >
            <el-option
              v-for="item in liushuiOptions"
              :key="item.value"
              :label="item.title"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <span class="title-span">会员：</span>
          <el-input
            size="small"
            style="width: 200px; margin-top: 20px"
            v-model="liushuiParams.queryValue"
            placeholder="会员电话、姓名"
            clearable
            @input="searchMember"
          ></el-input>
          <span class="title-span">时间：</span>
          <el-date-picker
            @change="dateChange"
            v-model="liushuiParams.createDateStart"
            size="small"
            class="title-date1"
            type="date"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            placeholder="选择开始日期"
          >
          </el-date-picker>
          至
          <el-date-picker
            @change="dateChange"
            v-model="liushuiParams.createDateEnd"
            size="small"
            class="title-date2"
            type="date"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            placeholder="选择结束日期"
          >
          </el-date-picker>
          <!--  -->
          <span class="title-span">门店筛选：</span>
          <el-select
            filterable
            clearable
            v-model="liushuiParams.shopId"
            size="small"
            placeholder="门店筛选"
            @change="shopIdChange"
          >
            <el-option
              v-for="item in mdSelectList"
              :label="item.name"
              :value="item.id"
              :key="item.id"
            ></el-option>
          </el-select>
          <!--  -->
        </div>
        <div class="mm-tb">
          <el-table :data="liushuiList" style="width: 100%">
            <el-table-column
              type="index"
              label="序号"
              align="center"
              width="80"
            >
            </el-table-column>
            <el-table-column prop="memberName" label="会员名称" align="center">
              <template slot-scope="scope">
                <div>
                  {{ scope.row.memberName ? scope.row.memberName : "" }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="changeType_text"
              label="类型"
              align="center"
              width="100"
            >
            </el-table-column>
            <el-table-column prop="oldValue" label="原值" align="center">
              <template slot-scope="scope">
                <div>
                  {{
                    scope.row.changeType == 7 || scope.row.changeType == 8
                      ? scope.row.oldName
                      : scope.row.oldValue
                  }}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="newValue" label="当前值" align="center">
              <template slot-scope="scope">
                <div>
                  {{
                    scope.row.changeType == 7 || scope.row.changeType == 8
                      ? scope.row.newName
                      : scope.row.newValue
                  }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="memberMobile"
              label="变化数量"
              align="center"
              width="100"
            >
              <template slot-scope="scope">
                {{
                  scope.row.changeType == 7 || scope.row.changeType == 8
                    ? ""
                    :
                     (convertNumber(scope.row.newValue) -
                      convertNumber(scope.row.oldValue))/100
                }}
              </template>
            </el-table-column>
            <el-table-column
              prop="createName"
              label="操作人"
              align="center"
              width="100"
            >
              <template slot-scope="scope">
                {{
                  scope.row.createName === "null" ? "" : scope.row.createName
                }}</template
              >
            </el-table-column>
            <el-table-column prop="shopName" label="门店" align="center">
            </el-table-column>
            <el-table-column prop="createDate" label="变化时间" align="center">
            </el-table-column>
            <el-table-column prop="remarks" label="变化原因" align="center">
            </el-table-column>
          </el-table>
        </div>
        <div>
          <el-pagination
            class="mm-page"
            @size-change="SizeChange"
            @current-change="liushuiCurrentChange"
            :current-page="liushuiResult.current"
            :page-size="liushuiResult.size"
            layout="total,prev, pager, next, sizes"
            :total="liushuiResult.total"
            :page-sizes="[10, 20, 30, 40, 50]"
          >
          </el-pagination></div
      ></el-tab-pane>
      <el-tab-pane label="会员成绩日志" name="twelve"> </el-tab-pane>
      <el-tab-pane label="会员比赛日志" name="thirteen"> </el-tab-pane>
      <el-tab-pane label="日榜" name="six"> </el-tab-pane>
      <el-tab-pane label="组数王" name="seven"> </el-tab-pane>
      <el-tab-pane label="资讯管理" name="one"> </el-tab-pane>
      <el-tab-pane label="活动管理" name="two"> </el-tab-pane>
      <el-tab-pane label="活动报名" name="three"> </el-tab-pane>
      <el-tab-pane label="赛事管理" name="four"> </el-tab-pane>
      <el-tab-pane label="日榜管理" name="five"> </el-tab-pane>

      <el-tab-pane label="段位管理" name="eight"> </el-tab-pane>
      <el-tab-pane label="勋章管理" name="nine"> </el-tab-pane>
      <el-tab-pane label="订单项管理" name="ten"> </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import {
  getAntMembersChangePage,
  memberInfoChange,
  getAntDeptSelect,
} from "../../api/BusinessManagement";
export default {
  name: "11MedalManagement",
  data() {
    return {
      activeName: "eleven",
      liushuiParams: {
        pageNo: 1,
        pageSize: 10,
        changeType: "",
        queryValue: "",
        createDateStart: "",
        createDateEnd: "",
      },
      liushuiList: [],
      liushuiResult: {},
      liushuiOptions: [],
      mdSelectList: [],
    };
  },
  created() {},
  mounted() {
    this.getAntMembersChangePage(this.liushuiParams);
    this.memberInfoChange();
    this.getAntDeptSelect();
  },
  methods: {
    handleClick(tab, event) {
      if (tab.label == "资讯管理") {
        this.$router.push("/OperationManagement/1InformationManagement");
      } else if (tab.label == "活动管理") {
        this.$router.push("/OperationManagement/2ActivityManagement");
      } else if (tab.label == "活动报名") {
        this.$router.push("/OperationManagement/3ActivityRegistration");
      } else if (tab.label == "赛事管理") {
        this.$router.push("/OperationManagement/4EventManagement");
      } else if (tab.label == "日榜管理") {
        this.$router.push("/OperationManagement/5RankingList");
      } else if (tab.label == "日榜") {
        this.$router.push("/OperationManagement/6ListManagement");
      } else if (tab.label == "组数王") {
        this.$router.push("/OperationManagement/7GroupNumberList");
      } else if (tab.label == "段位管理") {
        this.$router.push("/OperationManagement/8RankManagement");
      } else if (tab.label == "勋章管理") {
        this.$router.push("/OperationManagement/9MedalManagement");
      } else if (tab.label == "订单项管理") {
        this.$router.push("/OperationManagement/10MedalManagement");
      } else if (tab.label == "会员日志") {
        // this.$router.push("/OperationManagement/11MedalManagement");
      } else if (tab.label == "会员成绩日志") {
        this.$router.push("/OperationManagement/12MedalManagement");
      } else if (tab.label == "会员比赛日志") {
        this.$router.push("/OperationManagement/13MedalManagement");
      }
    },
    getAntMembersChangePage(params) {
      getAntMembersChangePage(params).then((res) => {
        if (res.status === 200 && res.data.success) {
          if (res.data.result.total === 0) {
            this.$Notice.open({
              title: "查无数据",
            });
            this.liushuiResult = res.data.result;
            this.liushuiList = res.data.result.records;
          } else {
            this.liushuiResult = res.data.result;
            this.liushuiList = res.data.result.records;
          }
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    SizeChange(newSize) {
      this.liushuiParams.pageSize = newSize;
      this.getAntMembersChangePage(this.liushuiParams);
    },
    liushuiCurrentChange(newPage) {
      this.liushuiParams.pageNo = newPage;
      this.getAntMembersChangePage(this.liushuiParams);
    },
    changeTypeSelect() {
      this.liushuiParams.pageNo = 1;
      this.getAntMembersChangePage(this.liushuiParams);
    },
    searchMember() {
      this.liushuiParams.pageNo = 1;
      this.getAntMembersChangePage(this.liushuiParams);
    },
    dateChange() {
      if (
        this.liushuiParams.createDateStart &&
        this.liushuiParams.createDateEnd &&
        new Date(this.liushuiParams.createDateStart).getTime() >
          new Date(this.liushuiParams.createDateEnd).getTime()
      ) {
        this.$message.error("开始时间不能大于结束时间");
        return;
      }
      this.liushuiParams.pageNo = 1;
      this.getAntMembersChangePage(this.liushuiParams);
    },
    memberInfoChange() {
      memberInfoChange().then((res) => {
        console.log(res.data.result);
        this.liushuiOptions = res.data.result;
      });
    },
    //获取门店下拉菜单
    getAntDeptSelect() {
      getAntDeptSelect().then((res) => {
        if (res.status === 200 && res.data.success) {
          if (res.data.result.total === 0) {
            this.$Notice.open({
              title: "暂无门店数据",
            });
          } else {
            this.mdSelectList = res.data.result;
          }
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    shopIdChange() {
      this.liushuiParams.pageNo = 1;
      this.getAntMembersChangePage(this.liushuiParams);
    },
    convertNumber(arg1) {
      const str = arg1.toString();
      let before, after, r1, m;
      if (str.indexOf(".") > -1) {
        before = arg1.toString().split(".")[0];
        after = arg1.toString().split(".")[1];
      } else {
        before = str;
        after = "0";
      }
      after = after.padEnd(2, 0);
      //beishu = Math.pow(10, after.length);
      return parseInt(before * 100 + after * 1);
    },
  },
};
</script>
<style scoped>
.title-span {
  font-size: 16px;
  margin-left: 30px;
}

.orderMain {
  padding: 30px;
}

.title_div {
  margin: 20px 30px;
}

.title-select {
  margin: 0 20px;
  width: 200px;
}

.title-date1 {
  width: 180px;
}

.title-date2 {
  width: 180px;
}

.creat-button {
  margin: 20px 80px;
}

.mm-tb {
  width: 90%;
  margin-left: 50px;
}

.mm-page {
  margin: 30px 60px;
}
</style>